import React from "react";

export default function TopBar({ view, onChangeView, onLogout }) {
  const onCarsPage = view === "cars";
  return (
    <header className="dams-topbar">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-baseline gap-2">
          <span className="dams-brand-name text-xl">DAMS</span>
          <span className="dams-brand-sub">CAR RENTAL</span>
        </div>
        <nav className="flex items-center gap-2 flex-wrap">
          {onCarsPage ? (
            <>
              <button className="pill-btn ghost" onClick={() => onChangeView("bookings")}>Bookings</button>
              <button className="pill-btn ghost" onClick={() => onChangeView("locations")}>Locations</button>
              <button className="pill-btn blue" onClick={() => onChangeView("importexport")}>Import/Export</button>
            </>
          ) : (
            <button className="pill-btn ghost" onClick={() => onChangeView("cars")}>← Cars</button>
          )}
          <button className="pill-btn ghost" onClick={onLogout}>Logout</button>
        </nav>
      </div>
    </header>
  );
}
